(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsTreeView', rmsTreeView);

    function rmsTreeView() {
        return {
            restrict: 'E',
            controller: rmsTreeViewCtrl,
            controllerAs: 'vm',
            scope: {
                items: '=',
                options: '=',
                onItemClick: '&?',
            },
            bindToController: true,
            templateUrl: 'common/app/components/treeview/treeview'
        };
    }

    function rmsTreeViewCtrl($templateCache, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.handleClick = function(item) {
                vm.onItemClick({ item: item });
            };

            if (lodash.has(vm.options, 'template')) {
                vm.template = vm.options.template;
            } else {
                if (lodash.has(vm.options, 'templateUrl')) {
                    vm.template = $templateCache.get(vm.options.templateUrl);
                } else {
                    vm.template = $templateCache.get('common/app/components/treeview/treeview-item');
                }
            }
        }
    }
})();